
export enum UserGroupErrorCode {
    NAME_ALREADY_EXISTS = "USER_GROUP_NAME_ALREADY_EXISTS",
}
